import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { ClipLoader } from 'react-spinners';
/*import { qpOpenModal } from "../../utils/misc";*/

class ShipmentsTable extends Component {
    state = {
        activeTab: 'all',
        searchTerm: '',
        pageIndex: 0,
        allSelected: false,
        selectedShipments: []
    };

    render() {

        let shipments = this.props.shipmentsList || [];

        return (
            <div className="card mb-4 table-responsive" style={{ height: 'auto' }}>
                <table className="table table-striped minayla-table">
                    {!this.props.isLoading && shipments.length > 0 && (
                        <thead>
                            <tr>
                                <th>Shipment</th>
                                <th>Order</th>
                                <th>Booking</th>
                                <th>Container</th>
                                <th>Size/Type</th>
                                <th>Status</th>
                                <th>ETA</th>
                                <th>Delivery Type</th>
                                <th>Terminal</th>
                                <th>Last Free Day</th>
                                <th>Port Status</th>
                                <th>Ref/BL#</th>
                                <th>Return Last Free Day</th>
                                <th>Consignee</th>
                                <th>Traverse Type</th>
                                <th></th>
                            </tr>
                            <tr id="gradient-row">
                                <td colSpan="16">
                                    <div id="gradient-bar" className="bg-primary bg-gradient" />
                                </td>
                            </tr>
                        </thead>
                    )}
                    <tbody>
                        {
                            !this.props.isLoading && shipments.length > 0 && (
                                shipments.map(shipment => {
                                    const status = shipment.containerStatus;
                                    const RefBL = shipment.referenceNumber != "" ? (shipment.billOfLadingNumber != "" ? shipment.referenceNumber + " - " + shipment.billOfLadingNumber : shipment.referenceNumber) : (shipment.billOfLadingNumber != "" ? shipment.billOfLadingNumber : "");
                                    const ports = {
                                        "PET-IMPORT": "https://ecp2.emodal.com/containers",
                                        "PET-EXPORT": "https://ecp2.emodal.com/bookings",
                                        "FIT-IMPORT": "https://forecast.fitpev.com/fc-FIT/import/default.do?method=container&eqptNbr=",
                                        "FIT-EXPORT": "https://forecast.fitpev.com/fc-FIT/export/default.do",
                                        "POMTOC-IMPORT": "https://pomtoc-online.tideworks.com/fc-POM/import/default.do?method=container&eqptNbr=",
                                        "POMTOC-EXPORT": "https://pomtoc-online.tideworks.com/fc-POM/export/default.do",
                                        "SFCT-IMPORT": "https://sfct.apmterminals.com/ContainerSearch.aspx?btnContainerSearch=Go&txtContainerNumber=",
                                        "SFCT-EXPORT": "https://sfct.apmterminals.com/BookingInquiry.aspx?btnBookingNumber=Go&txtBookingNumber="
                                    };
                                    const portslink = ports[shipment.fromLocationName + "-" + shipment.traverseType.toUpperCase()] + ((shipment.fromLocationName === "POMTOC" && shipment.traverseType.toUpperCase() === "IMPORT") || shipment.fromLocationName === "SFCT" || shipment.fromLocationName === "FIT" ? shipment.containerNumber : "");
                                    let badgeClass = status === 'PENDING' ? 'badge-bg-green' : (status === 'OPEN' ? 'badge-light' : (status === 'AVAILABLE' ? 'badge-bg-blue' : (status === 'SCHEDULED' ? 'badge-bg-yellow' : (status === 'DISPATCHED' ? 'badge-bg-purple' : (status === 'DELIVERED' ? 'badge-info' : (status === 'COMPLETED' ? 'badge-primary' : (status === 'APPROVED' ? 'badge-success' : (status === 'DROPPED' ? 'badge-bg-red' : ''))))))));
                                    if (badgeClass.length) badgeClass += ' status-badge';

                                    return (
                                        <tr key={shipment.deliveryContainerId}>
                                            <td>{shipment.deliveryContainerId}</td>
                                            <td>{shipment.orderNumber}</td>
                                            <td>{shipment.bookingNumber}</td>
                                            <td>{shipment.containerNumber}</td>
                                            <td>{shipment.containerSize} {shipment.containerType.split(" - ")[1]}</td>
                                            <td>
                                                <div className={`mx-auto ${badgeClass}`}>{badgeClass.length ? shipment.containerStatus.toLowerCase() : shipment.containerStatus}</div>
                                                
                                            </td>
                                            <td>{shipment.etaDate}</td>
                                            <td>{shipment.deliveryType}</td>
                                            <td>{portslink == null || portslink == "undefined" ? shipment.fromLocationName : <a href={`${portslink}`} target='_blank' style={{ fontWeight: 'bold' }}>{shipment.fromLocationName}</a>}</td>
                                            <td>{shipment.lastFreeDayDate}</td>
                                            <td>{shipment.portStatusName}</td>
                                            <td>{RefBL}</td>
                                            <td>{shipment.returnLastFreeDayDate}</td>
                                            <td>{shipment.toLocationName}</td>
                                            <td>{shipment.traverseType}</td>
                                            <td>
                                                <div className="d-flex flex-row justify-content-center">
                                                    <button onClick={() => this.props.openModal(shipment.deliveryContainerId, shipment.orderNumber)}
                                                        className="btn btn-primary icon-btn" data-toggle="modal" data-target="#invoice-modal" title="View Documents">
                                                        <FontAwesomeIcon icon={faFolderOpen} size="lg" />
                                                    </button>
                                                </div>
                                                {status === 'DROPPED' && shipment.isReadyForPickup ?
                                                    <div className="d-flex flex-row justify-content-center" style={{ paddingTop: '10px' }}>
                                                        <button
                                                            onClick={() => this.props.openReadyForPickUpModal(shipment.deliveryContainerId)}
                                                            className="btn btn-primary icon-btn" data-toggle="modal" data-target="#shipmentreadyForPickuP"
                                                            title="Ready fro pickup">
                                                            <i class="batch-icon batch-icon-calendar"></i>
                                                        </button>

                                                    </div> : null}
                                            </td>
                                        </tr>
                                    );
                                })
                            )
                        }
                    </tbody>
                </table>
                {
                    !this.props.isLoading && !shipments.length && (<div style={{
                        textAlign: 'center',
                        padding: '50px',
                        fontSize: '20px',
                        backgroundColor: '#fff'
                    }}>NO SHIPMENT FOUND</div>)
                }
                {
                    this.props.isLoading &&
                    <div className='sweet-loading' style={{
                        textAlign: 'center', height: '200px',
                        backgroundColor: '#fff'
                    }}>
                        <ClipLoader
                            sizeUnit={"px"}
                            size={150}
                            color={'rgb(54, 215, 183)'}
                            loading={true}
                        />
                    </div>
                }
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        shipmentsList: state.shipmentData.list,
        isLoading: state.shipmentData.isLoading,
        counts: state.shipmentData.counts,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        /*openDocumentsModal: this.openModal,*/
        /*openReadyForPickUpModal: this.openReadyForPickUpModal*/
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentsTable);


// WEBPACK FOOTER //
// ./src/view/Shipment/ShipmentsTable.js